const PackingBoxSVG = ({ color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 512 512"
    fill="none"
    xmlSpace="preserve"
    {...props}
  >
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    >
      {/* Front face — larger footprint to match DeliveryTruck (~15–497 span) */}
      <path
        d="M72 428V132h268v296H72z"
        stroke="#f6a237"
        strokeWidth={28}
      />
      {/* Top / lid */}
      <path
        d="M72 132l68-62H408l-68 62H72z"
        stroke="#f6a237"
        strokeWidth={28}
      />
      {/* Right face (aligned with top at 408,70 and front at 340,132–428) */}
      <path
        d="M340 132L408 70V366L340 428V132"
        stroke="#f6a237"
        strokeWidth={28}
      />
      {/* Accent — label / tape */}
      <path
        d="M118 274h190"
        stroke={color || '#F6A237'}
        strokeWidth={28}
      />
    </g>
  </svg>
)

export default PackingBoxSVG
